"use strict";

/**
 * @description Dashboard Component
 * @returns {Object} Devuelve la instancia del componente
 */

import { render } from "lit-html";
import { templateLayoutMain } from "./layoutMain.template";
import { store } from "../../../app.init.js";

let componentLayoutMain = (function () {
  let context = {};
  let handlers = {};
  let renderSuccess = false;

  let preRenderComponent = () => {
    // Asi accedemos a la propiedad del store
    const state = store.getState();
    context.name = state.exampleReducer.name;
  };

  let renderComponent = (children) => {
    try {
      // Render the template to the document
      render(
        // Define a template
        templateLayoutMain(children),
        document.querySelector("#esios-main-page")
      );
      renderSuccess = true;
    } catch (error) {
      renderSuccess = false;
    }
  };

  let postRenderComponent = () => {
    const state = store.getState();
    context.name = state.exampleReducer.name;
  };

  let init = (children) => {
    //Call pre render component
    preRenderComponent();

    // Call render component
    renderComponent(children);

    // Call post render component if it has been rendered
    renderSuccess ? postRenderComponent() : "";
  };

  return {
    render: (children) => init(children),
  };
})();

export { componentLayoutMain };